module.exports = __webpack_public_path__ + "static/media/loading1.b4de1306.gif";